<template>
    <FirstPage :section="11" :audio="true">
        <p>Did you know that there are {{ stepsOrder.length }} steps to using a condom the right way?</p>
    </FirstPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        stepsOrder: get('section11/stepsOrder')
    }
};
</script>
